"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentClientError = void 0;

var PaymentClientError =
/** @class */
function (_super) {
  __extends(PaymentClientError, _super); // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types


  function PaymentClientError(message, shortCode, details) {
    var _newTarget = this.constructor;

    var _this = _super.call(this, message) || this;

    _this.name = "PaymentClientError";
    _this.shortCode = shortCode;
    _this.details = details;
    var trueProto = _newTarget.prototype;
    _this.__proto__ = trueProto;
    return _this;
  }

  return PaymentClientError;
}(Error);

exports.PaymentClientError = PaymentClientError;


// WEBPACK FOOTER //
// ./node_modules/@backoffice/fast-payments-client-js-sdk/build/src/PaymentClient/Errors/PaymentClientError.js